import BusComp from './Bus';

export interface Bus {
    emit(event: string, ...args: any[]);

    once(event: string, callback: (...args: any[]) => void);

    on(event: string, callback: (...args: any[]) => void);

    off(event: string, callback: (...args: any[]) => void);
}

export default new BusComp() as Bus;
